module.exports = __webpack_public_path__ + "static/img/curriculum.27a8fb5.png";


//////////////////
// WEBPACK FOOTER
// ./public/hadoopImg/curriculum.png
// module id = RvuR
// module chunks = 0